<div class="modal-backdrop" *ngIf="visible" (click)="onClose()"></div>

<div class="modal" *ngIf="visible">
  <div class="modal-header">
    <h3>
      {{
        mode === 'view'
          ? 'View ' + entityLabel
          : mode === 'edit'
          ? 'Edit ' + entityLabel
          : mode === 'add'
          ? 'Add ' + entityLabel
          : 'Confirm Delete'
      }}
    </h3>
    <button class="close-btn" (click)="onClose()">×</button>
  </div>

  <div class="modal-body">
    <!-- VIEW MODE -->
    <div *ngIf="mode === 'view'">
      <div *ngFor="let key of keys" class="field">
        <label>{{ key }}</label>
        <p>{{ resolveDisplayValue(key) }}</p>
      </div>
    </div>

    <!-- EDIT / ADD MODE -->
    <div *ngIf="mode === 'edit' || mode === 'add'">
      <div *ngFor="let key of keys" class="field">
        <label>{{ key }}</label>

        <!-- readonly fields -->
        <input
          *ngIf="isReadonly(key)"
          [(ngModel)]="data[key]"
          [readonly]="true"
        />

        <!-- dropdowns for foreign keys -->
        <select *ngIf="isForeignKey(key)" [(ngModel)]="data[key]">
          <option *ngFor="let option of getLookupList(key)" [value]="option.value">
            {{ option.label }}
          </option>
        </select>

        <!-- normal editable -->
        <input
          *ngIf="!isReadonly(key) && !isForeignKey(key)"
          [(ngModel)]="data[key]"
          [placeholder]="
            mode === 'add' ? 'Enter ' + key : data[key] || ('Enter ' + key)
          "
        />
      </div>
    </div>

    <!-- DELETE MODE -->
    <div *ngIf="mode === 'delete'" class="delete-section">
      <p>
        Type <strong>{{ data?.name || entityLabel }}</strong> to confirm deletion.
      </p>
      <input [(ngModel)]="confirmInput" [placeholder]="data?.name || entityLabel" />
    </div>
  </div>

  <div class="modal-footer">
    <button class="cancel-btn" (click)="onClose()">Cancel</button>

    <button *ngIf="mode === 'view'" class="primary-btn" (click)="onClose()">Close</button>

    <button *ngIf="mode === 'edit'" class="primary-btn" (click)="onConfirm()">Save</button>

    <button *ngIf="mode === 'add'" class="primary-btn" (click)="onConfirm()">Create</button>

    <button
      *ngIf="mode === 'delete'"
      class="danger-btn"
      [disabled]="confirmInput !== data?.name"
      (click)="onConfirm()"
    >
      Delete
    </button>
  </div>
</div>
